import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const LOADING_STAGES = {
  bookings: "bookings",
  orders: "orders",
  printers: "printers",
  configuration: "configuration",
  buttons: "buttons",
  modules: "modules",
  services: "services",
  shifts: "shifts",
  employeeGroups: "employeeGroups",
  employees: "employees",
  general: "general",
  sections: "sections",
  tables: "tables",
  courses: "courses",
  productCategories: "productCategories",
  products: "products",
  labels: "labels",
  paymentMethods: "paymentMethods",
  user: "user",
} as const;

export type LoadingStage = keyof typeof LOADING_STAGES;

interface LoadingStoreState {
  initialized: boolean;
  setInitialized: (initialized: boolean) => void;
  currentLoadingStage?: LoadingStage;
  setCurrentLoadingStage: (currentLoadingStage?: LoadingStage) => void;
}

export const useLoadingStore = create<LoadingStoreState>()(
  devtools((set) => ({
    initialized: false,
    setInitialized(initialized) {
      set(() => ({ initialized }));
    },
    currentLoadingStage: undefined,
    setCurrentLoadingStage(currentLoadingStage) {
      set(() => ({ currentLoadingStage }));
    },
  }))
);
